/**
 * Connect25 system preference names (type `S`) and FileStore `file_key` values.
 * JSON shapes: see module comment on `theme-branding.ts`. Reactive load: `SeConnect25ThemeStore`.
 *
 * - `PREF_25L_CONNECT25_BRANDING`: single JSON object (header + home slideshow gradient colors, logo ref, etc.).
 */

/** System pref: Connect25 branding JSON (banner + home slideshow section gradient). */
export const PREF_25L_CONNECT25_BRANDING = "25L_connect25_branding";

/** FileStore pool for home slideshow background images (`object_type` / `object_id` = -1). */
export const FILE_KEY_CONNECT25_HOME_SLIDESHOW_POOL = "connect25_hero_slideshow";

/** FileStore key for optional top-banner logo (`object_type` / `object_id` = -1). */
export const FILE_KEY_CONNECT25_BANNER_LOGO = "connect25_banner_logo";

/** OLS template object_id for Connect25 workflow Create Organization (matches 25saas OrganizationsServiceImpl). */
export const CONNECT25_WORKFLOW_CREATE_ORG_DEFAULT_OLS_OBJECT_ID = -1008;
